import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useModalPageStore } from '../../shared/store/pageStore';
import { useTextListActions } from '../../shared/hooks/useApi/useTextList';
import { CurrPageButton, PageButton, PageWindowButton } from '../work/PageAboutWork';
import { LIMIT_PAGE_NUM } from '../../shared/constants/limits';
import { PerPage } from '../../shared/enum/EnumRepository';
import { useTextListStore } from '../../shared/store/TextListStore';

const PageAboutTextImport: React.FC = () => {
  const { modalPage } = useModalPageStore();
  const { getSimpleTextList } = useTextListActions();
  const textSortData = useTextListStore((s) => s.sortData);
  const [currentWindow, setCurrentWindow] = React.useState(1);

  useEffect(() => {
    getSimpleTextList({ page: 1, size: PerPage.PAGE_10, sortData: textSortData, filterData: {} });
  }, []);

  const handlePageClick = (pageNum: number) => {
    getSimpleTextList({ page: pageNum, size: PerPage.PAGE_10, sortData: textSortData, filterData: {} });
  };

  const handlePageWindowClick = (direction: 'prev' | 'next') => {
    if (direction === 'prev' && currentWindow > 1) {
      const newPage = (currentWindow - 2) * LIMIT_PAGE_NUM + 1;
      getSimpleTextList({ page: newPage, size: PerPage.PAGE_10, sortData: textSortData, filterData: {} });
      setCurrentWindow(currentWindow - 1);
    } else if (direction === 'next' && currentWindow < Math.ceil(modalPage.totalPages / LIMIT_PAGE_NUM)) {
      const newPage = currentWindow * LIMIT_PAGE_NUM + 1;
      getSimpleTextList({ page: newPage, size: PerPage.PAGE_10, sortData: textSortData, filterData: {} });
      setCurrentWindow(currentWindow + 1);
    }
  };

  const startPage = (currentWindow - 1) * LIMIT_PAGE_NUM + 1;
  const endPage = Math.min(startPage + LIMIT_PAGE_NUM - 1, modalPage.totalPages);

  useEffect(() => {
    const windowForCurrentPage = Math.ceil(modalPage.page / LIMIT_PAGE_NUM);
    if (windowForCurrentPage !== currentWindow) {
      setCurrentWindow(windowForCurrentPage);
    }
  }, [modalPage.page]);

  return (
    <PageContainer>
      {currentWindow > 1 && (
        <PageWindowButton onClick={() => handlePageWindowClick('prev')}>←</PageWindowButton>
      )}
      {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i)
        .map((pageNum) => (
          pageNum === modalPage.page ? (
            <CurrPageButton key={pageNum}>{pageNum}</CurrPageButton>
          ) : (
            <PageButton key={pageNum} onClick={() => handlePageClick(pageNum)}>{pageNum}</PageButton>
          )
        ))}
      {currentWindow < Math.ceil(modalPage.totalPages / LIMIT_PAGE_NUM) && (
        <PageWindowButton onClick={() => handlePageWindowClick('next')}>→</PageWindowButton>
      )}
    </PageContainer>
  );
};

export default PageAboutTextImport;

const PageContainer = styled.div`
  width: 100%;
  height: calc(3vh);
  display: flex;
  align-items: center;
  gap: clamp(10px, 0.5vw, 20px);
  padding-top: 10px;
  ${({ theme }) => theme.typography.Body_04};
`;
